module.exports = __webpack_public_path__ + "img/shoot-1.35a344fc.jpg";